import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './HomePageChild.module.css';
import signSymptoms1 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-1.png';
import signSymptoms2 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-2.png';
import signSymptoms3 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-3.png';
import signSymptoms4 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-4.png';
import signSymptoms5 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-5.png';
import signSymptoms6 from '../../assets/designSystem/icons/StaticPages/HomePage/sign- symptoms-6.png';
import firstAid1 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-1.png';
import firstAid2 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-2.png';
import firstAid3 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-3.png';
import firstAid4 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-4.png';
import firstAid5 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-5.png';
import firstAid6 from '../../assets/designSystem/icons/StaticPages/HomePage/first-aid-6.png';

const signsAndSymptomsCards = [
  {
    id: 'fever',
    titleKey: 'staticPages.homePageChild.cards.signs.fever',
    accentClassName: styles.pillRed,
    imageSrc: signSymptoms1,
    to: '/signs-symptoms/fever',
    className: 'leftTop',
  },
  {
    id: 'cough',
    titleKey: 'staticPages.homePageChild.cards.signs.cough',
    accentClassName: styles.pillOrange,
    imageSrc: signSymptoms2,
    to: '/signs-symptoms/cough',
    className: 'topRight',
  },
  {
    id: 'rash',
    titleKey: 'staticPages.homePageChild.cards.signs.rash',
    accentClassName: styles.pillYellow,
    imageSrc: signSymptoms3,
    to: '/signs-symptoms/rash',
    className: 'leftMiddle',
  },
  {
    id: 'diarrhoea',
    titleKey: 'staticPages.homePageChild.cards.signs.diarrhoea',
    accentClassName: styles.pillTeal,
    imageSrc: signSymptoms4,
    to: '/signs-symptoms/diarrhoea',
    className: 'rightLower',
  },
  {
    id: 'vomiting',
    titleKey: 'staticPages.homePageChild.cards.signs.vomiting',
    accentClassName: styles.pillBlue,
    imageSrc: signSymptoms5,
    to: '/signs-symptoms/vomiting',
    className: 'leftBottom',
  },
  {
    id: 'ear-pain',
    titleKey: 'staticPages.homePageChild.cards.signs.earPain',
    accentClassName: styles.pillAmber,
    imageSrc: signSymptoms6,
    to: '/signs-symptoms/ear-pain',
    className: 'rightLast',
  },
];

const firstAidCards = [
  {
    id: 'choking',
    titleKey: 'staticPages.homePageChild.cards.firstAid.choking',
    accentClassName: styles.pillRed,
    imageSrc: firstAid1,
    to: '/firstAid/choking',
    className: 'leftTop',
  },
  {
    id: 'burns',
    titleKey: 'staticPages.homePageChild.cards.firstAid.burnsAndScalds',
    accentClassName: styles.pillOrange,
    imageSrc: firstAid2,
    to: '/firstAid/burns',
    className: 'topRight',
  },
  {
    id: 'fractures',
    titleKey: 'staticPages.homePageChild.cards.firstAid.fractures',
    accentClassName: styles.pillYellow,
    imageSrc: firstAid3,
    to: '/firstAid/fractures',
    className: 'leftMiddle',
  },
  {
    id: 'nose-bleeding',
    titleKey: 'staticPages.homePageChild.cards.firstAid.noseBleeding',
    accentClassName: styles.pillTeal,
    imageSrc: firstAid4,
    to: '/firstAid/nose-bleeding',
    className: 'rightLower',
  },
  {
    id: 'cuts-wounds',
    titleKey: 'staticPages.homePageChild.cards.firstAid.cutsAndWounds',
    accentClassName: styles.pillBlue,
    imageSrc: firstAid5,
    to: '/firstAid/cuts-wounds',
    className: 'leftBottom',
  },
  {
    id: 'poisoning',
    titleKey: 'staticPages.homePageChild.cards.firstAid.poisoning',
    accentClassName: styles.pillYellow,
    imageSrc: firstAid6,
    to: '/firstAid/poisoning',
    className: 'rightLast',
  },
];

function ChildFlowItem({ titleKey, accentClassName, imageSrc, direction, to, rowClassName }) {
  const { t } = useTranslation();
  const title = t(titleKey);

  return (
    <div className={`${styles.flowItem} ${styles[rowClassName]}`}>
      <Link className={styles.flowLink} to={to}>
        <img className={styles.avatar} src={imageSrc} alt={title} />
        <span className={`${styles.itemLabel} ${accentClassName}`}>{title}</span>
      </Link>
    </div>
  );
}

ChildFlowItem.propTypes = {
  titleKey: PropTypes.string.isRequired,
  accentClassName: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['left', 'right']).isRequired,
  to: PropTypes.string.isRequired,
};

function ChildFlowList({ items }) {
  const { t } = useTranslation();

  return (
    <div className={styles.mapContainer}>
      <svg xmlns="http://www.w3.org/2000/svg" 
        className={styles.connectorSvg}
        width="450" 
        height="450" 
        viewBox="0 0 100 450"
        fill="none">
        <path 
          d="M84.2927 284.5C73.4998 278.267 0.341466 250.257 2.02948 244C15.8851 251 89.8163 205.297 95.2924 185C65.7735 155.432 39.5001 155.754 15.8851 135.056C92.6339 108.445 116.249 83.3124 86.7299 59.6578C57.2115 36.0034 30.6445 16.7842 7.02949 2.00024" 
          stroke="#D4A574" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeDasharray="15 10"
        />
      </svg>
      <ul className={styles.flowList} aria-label={t('staticPages.homePageChild.flowListLabel')}>
        {items.map((item, index) => (
          <ChildFlowItem
            key={item.id}
            titleKey={item.titleKey}
            accentClassName={item.accentClassName}
            imageSrc={item.imageSrc}
            direction={index % 2 === 0 ? 'left' : 'right'}
            to={item.to}
            rowClassName={item.className}
          />
        ))}
      </ul>
    </div>
  );
}

ChildFlowList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      titleKey: PropTypes.string.isRequired,
      accentClassName: PropTypes.string.isRequired,
      imageSrc: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default function HomePageChild() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(() => {
    return localStorage.getItem('homePageChildTab') || 'signs';
  });

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    localStorage.setItem('homePageChildTab', tab);
  };

  useEffect(() => {
    const syncTab = (event) => {
      setSelectedTab(event.detail || localStorage.getItem('homePageChildTab') || 'signs');
    };
    window.addEventListener('kito:child-tab-change', syncTab);
    return () => window.removeEventListener('kito:child-tab-change', syncTab);
  }, []);

  return (
    <section className={styles.childHomeContainer} aria-label="Home Page Child">
      <p className={styles.kidsTitle}>{t('staticPages.homePageChild.title')}</p>
      <p className={styles.subtitle}>{t('staticPages.homePageChild.subtitle')}</p>

      <div className={styles.tabSwitcher} role="tablist" aria-label={t('staticPages.homePageChild.tabListLabel')}>
        <button
          type="button"
          role="tab"
          className={`${styles.tabButton} ${selectedTab === 'signs' ? styles.tabButtonActive : ''}`}
          onClick={() => handleTabChange('signs')}
          aria-selected={selectedTab === 'signs'}
        >
          {t('staticPages.homePageChild.tabs.signs')}
        </button>

        <button
          type="button"
          role="tab"
          className={`${styles.tabButton} ${selectedTab === 'firstAid' ? styles.tabButtonActive : ''}`}
          onClick={() => handleTabChange('firstAid')}
          aria-selected={selectedTab === 'firstAid'}
        >
          {t('staticPages.homePageChild.tabs.firstAid')}
        </button>
      </div>

      {selectedTab === 'signs' ? <ChildFlowList items={signsAndSymptomsCards} /> : <ChildFlowList items={firstAidCards} />}
    </section>
  );
}
